module.exports = __webpack_public_path__ + "static/img/email.1683bc7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floating-button/email.png
// module id = LORI
// module chunks = 48